import { useState, useEffect } from 'react';

import { quirkyList, imageDictionary } from './ModelBrain';

import llm from '../../media/img/lab/pretrained-llm.png';
import agentOriginal from '../../media/img/lab/agent-placeholder.png';
import userInput from '../../media/img/lab/typing-hands.png';
import leftHand from '../../media/img/lab/left-hand.png';
import rightHand from '../../media/img/lab/right-hand.png';
import finishedProduct from '../../media/img/lab/finished-product.png';
import sleepy from '../../media/img/lab/egg-agents/sleepy.png';


function ModelDemo() {
  const [topIsOpen, setTopIsOpen] = useState(false);
  const [middleIsOpen, setMiddleIsOpen] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [randomThing, setRandomThing] = useState("");
  const [imageSrc, setImageSrc] = useState(agentOriginal);
  const [buttonClicked, setButtonClicked] = useState(false);
  useEffect(() => {
    const threshold = 30000; // 30 seconds
  if (!isTyping && !buttonClicked) {
    const timer = setTimeout(() => {
      sleepyTrigger();
    }, threshold);
    return () => clearTimeout(timer); // Cleanup
  }
  // If the user *is* active, clear and restart later
  return undefined;
}, [isTyping, buttonClicked]);
  
  function sleepyTrigger() {
    setImageSrc(sleepy);
    if (!unlockedWords.includes("zzz")) {
      const updatedList = [...unlockedWords, "zzz"];
      setUnlockedWords(updatedList);
      alert("You've unlocked agent 'zzz'. Type help for guide.");
    }
  }
  const [unlockedWords, setUnlockedWords] = useState([]);
  // Load unlocked words on mount
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("unlockedWords")) || [];
    setUnlockedWords(saved);
    // Restore last image too (optional)
    const savedImage = localStorage.getItem("lastImage");
    if (savedImage) {
      setImageSrc(savedImage);
    }
  }, []);
  function cleanInput(str) {
    return str
      .toLowerCase()               // make lowercase
      .replace(/[^a-z0-9]/g, "");  // remove everything except letters and numbers
  }
 const handleSubmit = (e) => {
    e.preventDefault();
    let inputString = cleanInput(inputValue);
    if (inputString === "") return;
    if (inputString === "agent") {
      setImageSrc(agentOriginal);
      setInputValue("");
      return;
    }
    if (inputString === "help") {
      if (unlockedWords.length === 0) {
        alert("You haven't unlocked any yet!");
      } else {
        alert("Unlocked so far: Agent (original), " + unlockedWords.join(", "));
      }
      setInputValue("");
      return;
    }
    // If input matches a dictionary key
    if (imageDictionary[inputString]) {
      const newImage = imageDictionary[inputString];
      setImageSrc(newImage);
      // Update unlocked words if it's new
      if (!unlockedWords.includes(inputString)) {
        const updated = [...unlockedWords, inputString];
        setUnlockedWords(updated);
        localStorage.setItem("unlockedWords", JSON.stringify(updated));
      }
      // Save last image
      localStorage.setItem("lastImage", newImage);
      setInputValue("");
    } else {
      // pick random thing on submit
      const picked = quirkyList[Math.floor(Math.random() * quirkyList.length)];
      setRandomThing(picked);      
      setIsSubmitted(true);
      setInputValue(""); // clear input
      setTopIsOpen(false);
      setMiddleIsOpen(false);
    }
  };
  return (
    <section className={`demo-model f-col ${isSubmitted ? 'product-screen' : ''}`}>
      <div className="flex">
        <div className="left-panel f-col">
          <img
            src={llm}
            className="agent-part"
            onClick={() => setTopIsOpen(!topIsOpen)}
          />
          <div className={`conditional-div pdb-25 ${topIsOpen ? 'open' : ''}`}>
            <h4>LLM (Pre-training)</h4>
            <p>
              The neural network of your choice, seeped in all that juicy data and ready for fine tuning. 
              This is the black box, a big suggestable cloud of language (not words, language) that will power our agent's brain.
            </p>
          </div>

          <img
            src={imageSrc}
            className="agent-part"
            onClick={() => setMiddleIsOpen(!middleIsOpen)}
          />
          <div className={`conditional-div pdb-25 ${middleIsOpen ? 'open' : ''}`}>
            <h4>Agent</h4>
            <p>
              The ideal agent is an intricate system of virtual elements working in harmony to produce predictable, reliable, 
              and efficient results in response to the user's (my) input. This involves memory storage and retrieval techniques (RAG), 
              context tuning, Few Shot prompting, training on personal and purpose specific data, IDE integration... too much for now. 
              I will add more as I better understand format it. 
            </p>
          </div>
          <form className="flex space-even w-600px" onSubmit={handleSubmit}>
            <input
              className="agent-input"
              type="text"
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
                setIsTyping(true);
              }}
              onBlur={() => setIsTyping(false)}
              placeholder="Ask me for something"
            />
            <button type="submit" className="btn">GO</button>
          </form>
          <div className="typing-hands">
            <img src={leftHand} className={`agent-part hand ${isTyping ? 'typing' : ''}`} />
            <img src={rightHand} className={`agent-part hand ${isTyping ? 'typingdelay' : ''}`} />
            <img src={userInput} className="agent-part keyboard" />
          </div>
        </div>
        <div className="right-panel">
          <h5 className="mb-25">The Agent gives you a...</h5>
          <div className="product-text">
            <h3 className="t-cen random-thing">{randomThing || "Placeholder"}</h3>
            <h2 className="mb-25 t-cen"><span className="dot1">.</span><span className="dot2">.</span><span className="dot3">.</span></h2>
            <div className="go-easy">
              <p className="mb-10">Go easy on them, ok. They're just a baby </p>
              <button className="btn product" onClick={() => setIsSubmitted(false)}>
                Back
              </button>
            </div>
          </div>
          <img src={finishedProduct} className="finished-product" />
        </div>
      </div>
      <dialog>
        <div></div>
      </dialog>
    </section>
  );
}
export default ModelDemo;
